module.exports = __webpack_public_path__ + "img/5.58d64502.png";